var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Text, View } from 'react-native';
import Icon from '../Icon';
import Space from '../Space';
import { useGroupContext } from './context';
import { useRadioStyle } from './style';
export function Radio(props) {
    const { checked, disabled, value = null, label, onChange: outerOnChange, onPress, children, } = props;
    const groupContext = useGroupContext();
    const finalChecked = checked !== null && checked !== void 0 ? checked : (groupContext === null || groupContext === void 0 ? void 0 : groupContext.value) === value;
    const { radioStyle } = useRadioStyle();
    const finaleLabel = label !== null && label !== void 0 ? label : children;
    function onChange(isChecked) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (groupContext) {
                if (value !== groupContext.value) {
                    (_a = groupContext.onChange) === null || _a === void 0 ? void 0 : _a.call(groupContext, value, isChecked);
                }
                return;
            }
            yield (outerOnChange === null || outerOnChange === void 0 ? void 0 : outerOnChange(isChecked));
        });
    }
    return (React.createElement(Space, { gap: 4, activeOpacity: 1, onPress: () => {
            onPress === null || onPress === void 0 ? void 0 : onPress();
            if (!disabled) {
                onChange === null || onChange === void 0 ? void 0 : onChange(!finalChecked);
            }
        } },
        finalChecked ? (React.createElement(Icon, { customStyle: { iconSize: 16 }, uri: "https://g-static.ap4r.com/kos/s101/nlav11312/shop-c-h5/check_red.png" })) : (React.createElement(View, { style: [
                radioStyle.base,
                radioStyle.unCheck,
                disabled ? radioStyle.disable : null,
            ] })),
        ['string', 'number'].includes(typeof finaleLabel) ? (React.createElement(Text, { style: [radioStyle.textStyle] }, finaleLabel)) : (finaleLabel)));
}
export default Radio;
